"use strict";

function shouldTaskAppearToday(task, selectedDate) {
  var checkDate = new Date(selectedDate);
  checkDate.setHours(23);
  checkDate.setMinutes(59);
  checkDate.setSeconds(59);
  var startDate = new Date(task.startDate);
  if (!task.repeatData) task.repeatData = {};
  var endRepeat = task.repeatData.repeatEnds
    ? new Date(task.repeatData.repeatTill)
    : null;

  // we set the endrepeat to last moment of the day
  if (endRepeat) {
    endRepeat.setHours(23);
    endRepeat.setMinutes(59);
    endRepeat.setSeconds(59);
  }

  var weekDays = {
    0: "sunday",
    1: "monday",
    2: "tuesday",
    3: "wednesday",
    4: "thursday",
    5: "friday",
    6: "saturday",
  };

  //if task is not marked as repeat, show it...because it was filtered by the api
  if (!task.repeat) {
    return true;
  }

  var daysDiff = Math.floor((checkDate - startDate) / (1000 * 60 * 60 * 24));

  //dont show if it repeats but we are viewing a previous than creation date
  if (daysDiff < 0) {
    return false;
  }

  //if repeat ends, we check if we should show it...
  if (endRepeat && endRepeat - checkDate < 0) {
    return false;
  }

  if (task.repeatData.repeatType === "daily") {
    var diff = daysDiff % task.repeatData.repeatEvery;
    //if the diff between days passed and repeat every is exact, we know we have to show the task.
    if (!diff) {
      return true;
    }
    return false;
  }

  if (task.repeatData.repeatType === "weekly") {
    var weekDay = checkDate.getDay();
    //we check to see if selectedDate week day is true or false...
    if (task.repeatData.repeatWeekDays[weekDays[weekDay]]) {
      return true;
    }
    return false;
  }
}

module.exports = function (
  $state,
  departments,
  $stateParams,
  myDepartments,
  $scope,
  tasks,
  toast,
  $translate,
  uiCalendarConfig
) {
  var _this = this;
  this.department = departments.filter(function (department) {
    return department.id === $state.params.departmentId;
  })[0];

  var departmentIDLocalStorage = localStorage.getItem("departmentId");
  // If 'departmentId' key exists in localStorage and is different from the current value, 'membsCFG' is deleted from localStorage."
  if (departmentIDLocalStorage) {
    if (departmentIDLocalStorage !== this.department.id) {
      localStorage.removeItem("membersCFG");
    }
  }
  // Store the departmentID in localStorage
  localStorage.setItem("departmentId", this.department.id);

  this.tasks = Array.isArray(tasks) ? tasks : [];
  this.members = JSON.parse(localStorage.getItem("membersCFG") || "[]");
  this.selectedAll = false;

  // Calendar Filter Status:
  this.whiteFilter = false;
  this.greenFilter = false;
  this.yellowFilter = false;
  this.redFilter = false;

  this.userPressed = (email) => {
    let member = _this.members.findIndex((member) => member.email == email);
    if (_this.members[member].hide != true) {
      _this.members[member].hide = true;
      $scope.eventSources.forEach((eventsUser, idx) => {
        eventsUser.email == email && $scope.eventSources.splice(idx, 1);
      });
    } else {
      _this.members[member].hide = false;
      let eventsUser = _this.tasksToCalendar.find(
        (eventsUser) => eventsUser.email == email
      );
      $scope.eventSources.push(eventsUser);
    }
    // Set in localStorage the members selected (only for tab tasks scope)
    localStorage.setItem("membersCFG", JSON.stringify(_this.members));
    this.changeSelectedAllButtonStatus(); // Update selectedAll status
    
    this.filterCalendar();
    
    return;
  };

  this.changeSelectedAllButtonStatus = () => {
    var member = _this.members.find((member) => member.hide === true);
    if (member) {
      this.selectedAll = false;
    } else {
      this.selectedAll = true;
    }
  }

  this.selectAll = () => {
    // For checkbox, value change is automatic.
    // this.selectedAll = !this.selectedAll;
    _this.members.forEach((member, index) => {
      member.hide = !this.selectedAll;
      if (this.selectedAll != true) {
        $scope.eventSources.forEach((eventsUser, idx) => {
          if (eventsUser.email) { eventsUser.email == member.email && $scope.eventSources.splice(idx, 1); }
        });
      } else {
        let eventsUser = _this.tasksToCalendar.find((eventsUser) => eventsUser.email == member.email);
        $scope.eventSources.push(eventsUser);
      }
    })
    localStorage.setItem("membersCFG", JSON.stringify(_this.members));

    this.filterCalendar();
  }

  this.changeFilterStatus = (color) => {
    // console.log('Entró color:', color);
    switch (color) {
      case 'white':
        this.whiteFilter = !this.whiteFilter;
        break;
      case 'green':
        this.greenFilter = !this.greenFilter;
        break;
      case 'yellow':
          this.yellowFilter = !this.yellowFilter;
          break;
      case 'red':
        this.redFilter = !this.redFilter;
        break;
    
      default:
        break;
    }

    // Filter events from calendar
    this.filterCalendar();
  }

  this.filterCalendar = () => {
    // console.log('this.redFilter', this.redFilter);
    // console.log('this.yellowFilter', this.yellowFilter);
    // console.log('this.greenFilter', this.greenFilter);
    // console.log('this.whiteFilter', this.whiteFilter);

    // Empty $scope.eventSources.
    while ($scope.eventSources.length > 0) {
      $scope.eventSources.pop();
    }

    // Create an array to store users and their events.
    const filteredEvents = [];
    // console.log('_this.members', _this.members)
    // console.log('_this.tasksToCalendar', _this.tasksToCalendar)

    _this.members.forEach((member) => {
      // console.log('member.hide', member.hide);
      if (member.hide === true) {
        // Do nothing
      } else {
        // Filter events from the user
        const eventsUser = _this.tasksToCalendar.find(
          (eventsUser) => eventsUser.email === member.email
        );
        
        if (eventsUser) {
          let filteredItems = [];

          // If no filter is selected
          if (!this.whiteFilter && !this.greenFilter && !this.yellowFilter && !this.redFilter) {
            filteredItems = eventsUser.events;
          }
          else {
            let filterColorsEvents = {
              white: [],
              green: [],
              yellow: [],
              red: [],
            };
            
            eventsUser.events.forEach((event) => {
              
              if (event.deptId !== undefined && event.start < new Date()) {              
                if (event.items.length === 0) {
                  filterColorsEvents.red = filterColorsEvents.red.concat([event]);
                } else {
                  let eventAreGreen = true;
                  event.items.forEach((item) => {
                    if (item.closedAt <= event.end?.toISOString()) {
                      eventAreGreen = eventAreGreen && true;
                    } else {
                      eventAreGreen = false; 
                    }
                  })
                  if (eventAreGreen) {
                    filterColorsEvents.green = filterColorsEvents.green.concat([event]);
                  } else {
                    filterColorsEvents.yellow = filterColorsEvents.yellow.concat([event]);
                  }
                }
              } else {
                filterColorsEvents.white = filterColorsEvents.white.concat([event]);
              }
            })
            
            if (this.whiteFilter) {
              filteredItems = filteredItems.concat(filterColorsEvents.white);
            }
            if (this.greenFilter) {
              filteredItems = filteredItems.concat(filterColorsEvents.green);
            }
            if (this.yellowFilter) {
              filteredItems = filteredItems.concat(filterColorsEvents.yellow);
            }
            if (this.redFilter) {
              filteredItems = filteredItems.concat(filterColorsEvents.red);
            }
          }          
          // All user events are added, and the user is included in filteredEvents."
          const filteredEventUser = { ...eventsUser, events: filteredItems };
          filteredEvents.push(filteredEventUser);
        }
      }
    });
    // Update events in the calendar
    filteredEvents.forEach(item => $scope.eventSources.push(item));
  };

  
  // It's necessary for both members and tasks to be loaded.
  if (Array.isArray(this.members) && this.members.length > 0 && this.tasks?.length > 0) {
    this.members?.forEach((member, idx) => {
      if (tasks?.findIndex((taskMember) => taskMember?.email == member.email) < 0)
        _this.members.splice(idx, 1);
    });
  }
  let myDepts = myDepartments.get();
//   console.log('llamado 8 myDepartments.get()')
  let firstDate = new Date();
  firstDate = new Date(firstDate.getFullYear(), firstDate.getMonth(), 0);
  if ($stateParams.startDate) firstDate = new Date($stateParams.startDate);
  firstDate.setHours(0);
  firstDate.setMinutes(0);
  firstDate.setSeconds(0);
  firstDate.setMilliseconds(0);
  $scope.eventSources = [];
  _this.tasksToCalendar = _this.tasks.reduce((events, member, idx) => {
    let memberCfg = _this.members.find((cfg) => cfg.email == member.email);
    if (memberCfg == undefined) {
      let r = Math.floor(Math.random() * (235 + 1));
      let g = Math.floor(Math.random() * (205 + 1));
      let b = Math.floor(Math.random() * (200 + 1));
      let a = Math.floor(Math.random() * 50 + 50);
      memberCfg = {
        color: "".concat("rgba(", r, ",", g, ",", b, ",", a / 100, ")"),
        bgColor: "".concat("rgba(", r, ",", g, ",", b, ",", "0.2)"),
        email: member.email,
        lastName: member.lastName,
        firstName: member.firstName,
        profileUrl: member.profileUrl,
        hide: true,
      };
      _this.members.push(memberCfg);
    }
    events.push({
      color: memberCfg.color,
      email: member.email,
      events: [].concat(
        member.task == undefined
          ? []
          : member.task.reduce((lst, task) => {
              let deptId =
                myDepts.findIndex((dept) => dept.id == task.departmentId) >= 0
                  ? task.departmentId
                  : undefined;

              let startDate = new Date(task.startDate);
              let endDate = new Date(task.endDate);
              if (task.repeat == true) {
                for (let i = 0; i < 60; i++) {
                  let date = new Date(firstDate);
                  date.setDate(date.getDate() + i);
                  if (shouldTaskAppearToday(task, date)) {
                    startDate = new Date(date);
                    startDate.setHours(new Date(task.startDate).getHours());
                    startDate.setMinutes(new Date(task.startDate).getMinutes());
                    startDate.setSeconds(new Date(task.startDate).getSeconds());

                    endDate = new Date(date);
                    endDate.setHours(new Date(task.endDate).getHours());
                    endDate.setMinutes(new Date(task.endDate).getMinutes());
                    endDate.setSeconds(new Date(task.endDate).getSeconds());
                    let items =
                      deptId != undefined
                        ? member.items.filter(
                            (item) =>
                              item["taskId"] == task.id &&
                              item["closedAt"] >
                                startDate.toISOString().substring(0, 10) &&
                              item["closedAt"] <
                                endDate
                                  .toISOString()
                                  .substring(0, 10)
                                  .concat("T23:59:59.999Z")
                          )
                        : [];
                    lst.push({
                      id: task.id,
                      title: task.name,
                      start: startDate,
                      end: endDate,
                      allDay: task.allDay,
                      items: items,
                      deptId: deptId,
                      deptName: task.department.name,
                      clientName: task.client?.name,
                      email: member.email,
                    });
                  }
                }
              } else {
                let items =
                  deptId != undefined
                    ? member.items.filter((item) => item["taskId"] == task.id)
                    : [];
                lst.push({
                  id: task.id,
                  title: task.name,
                  start: startDate,
                  end: endDate,
                  allDay: task.allDay,
                  items: items,
                  deptId: deptId,
                  deptName: task.department.name,
                  clientName: task.client?.name,
                  email: member.email,
                });
              }
              return lst;
            }, [])
      ),
    });
    memberCfg.hide==false && $scope.eventSources.push(events[events.length - 1]);
    return events;
  }, []);
  _this.members = _this.members.sort((a,b)=>a.firstName.concat(a.lastName).localeCompare(b.firstName.concat(b.lastName)));
  localStorage.setItem("membersCFG", JSON.stringify(_this.members));
  this.changeSelectedAllButtonStatus();

  $scope.eventsRefresh = function (start, end, timezone, callback) {
    if (
      $stateParams.startDate != start.toDate() ||
      $stateParams.endDate != end.toDate()
    ) {
      localStorage.setItem("membersCFG", JSON.stringify(_this.members));
      $state.go(
        "dashboard.departments.department.tasks",
        {
          startDate: start.toDate(),
          endDate: end.toDate(),
        },
        {
          location: "replace",
        }
      );
    } else callback([]);
  };
  
  $scope.eventSources.push($scope.eventsRefresh);

  this.calendarOnClick = function (task, jsEvent, view) {

    if (_this.department.id === task.deptId) {
      $state.go("dashboard.departments.department.tasks.task", {
        id: task.deptId,
        departmentId: task.deptId,
        taskId: task.id,
        items: task.items,
      });
    } else {
        toast.errorNoTimeout($translate.instant('DASHBOARD.DASH_TASKS.TASK_NO_AUTHORIZED'));
    }
  };

  _this.eventRender = function (event, element, view) {
    if (event.end == undefined) console.log(event.end, event);
    let tooltip = event.start
      .toDate()
      .toLocaleTimeString()
      .substr(0, 5)
      .concat(
        " - ",
        event.end ? event.end.toDate().toLocaleTimeString().substr(0, 5) : "",
        " ",
        event.email,
        "\n",
        event.deptName.concat(" -> ", event.title),
        "\n",
        event.clientName
      );
    element.attr("title", tooltip);
    let icon = "";
    if (event.title == "Chequear MataFuegos") console.log(1);
    let strListItems = "";
    if (event.items.length > 0) {
      // console.log('INICIAL event', event.items)
    }
    if (event.deptId != undefined && event.start.toDate() < new Date()) {
      icon = event.items.reduce((icon, item) => {
        strListItems = strListItems.concat(
          " * ",
          new Date(item.closedAt).getYYYYMMddHHmmss().substring(0, 16),
          "\n"
        );
        if (item.closedAt <= event.end?.toDate().toISOString()) {
          icon =
            '<i class="icon ion-checkmark-circled" style="color: green;"></i>';
        } else {
          icon =
            '<i class="icon ion-alert-circled" style="color: yellow;"></i>';
        }
        return icon;
      }, '<i class="icon ion-close-circled" style="color: red;"></i>');
    }
    tooltip =
      strListItems != ""
        ? tooltip.concat("\nFecha Hora Formulario Cerrado\n", strListItems)
        : tooltip;
    element.attr("title", tooltip);
    element[0].children[0].innerHTML = icon.concat(
      element[0].children[0].innerHTML
    );
  };

  this.calendarConfig = {
    defaultDate: new Date(firstDate.getFullYear(), firstDate.getMonth() + 1, 1),
    header: {
      left: "today prev,next greenButton,yellowButton,redButton,whiteButton",
      center: "title",
      right: "month,agendaWeek,agendaDay",
    },
    customButtons: {
      whiteButton: {
        text: 'custom!',
        click: () => {
          this.changeFilterStatus('white');

          // Add or remove the 'active' class based on the state.
          const buttonElement = document.querySelector('.fc-whiteButton-button');
          if (this.whiteFilter) {
            buttonElement.classList.add('fc-state-down', 'fc-state-active');
          } else {
            buttonElement.classList.remove('fc-state-down', 'fc-state-active');
          }
        },
        icon: "icon ion-ios-timer-outline",
      },
      greenButton: {
        text: 'custom!',
        click: () => {
          this.changeFilterStatus('green');
  
          // Add or remove the 'active' class based on the state.
          const buttonElement = document.querySelector('.fc-greenButton-button');
          if (this.greenFilter) {
            buttonElement.classList.add('fc-state-down', 'fc-state-active');
          } else {
            buttonElement.classList.remove('fc-state-down', 'fc-state-active');
          }
        },
        icon: "icon ion-checkmark-circled",
      },
      yellowButton: {
        text: 'custom!',
        click: () => {
          this.changeFilterStatus('yellow');

          // Add or remove the 'active' class based on the state.
          const buttonElement = document.querySelector('.fc-yellowButton-button');
          if (this.yellowFilter) {
            buttonElement.classList.add('fc-state-down', 'fc-state-active');
          } else {
            buttonElement.classList.remove('fc-state-down', 'fc-state-active');
          }
        },
        icon: "icon ion-alert-circled",
      },
      redButton: {
        text: 'custom!',
        click: () => {
          this.changeFilterStatus('red');

          // Add or remove the 'active' class based on the state.
          const buttonElement = document.querySelector('.fc-redButton-button');
          if (this.redFilter) {
            buttonElement.classList.add('fc-state-down', 'fc-state-active');
          } else {
            buttonElement.classList.remove('fc-state-down', 'fc-state-active');
          }
        },
        icon: "icon ion-close-circled",
      }
    },
    dayOfMonthFormat: "dddd D/M",
    eventClick: _this.calendarOnClick,
    eventRender: _this.eventRender,
    dayClick: function (date, jsEvent, view) {
      if (view.name == "month") {
        uiCalendarConfig.calendars["myCalendarTasks"].fullCalendar(
          "changeView",
          "agendaWeek"
        );
        uiCalendarConfig.calendars["myCalendarTasks"].fullCalendar(
          "gotoDate",
          date
        );
      } else if (view.name == "agendaWeek") {
        uiCalendarConfig.calendars["myCalendarTasks"].fullCalendar(
          "changeView",
          "agendaDay"
        );
        uiCalendarConfig.calendars["myCalendarTasks"].fullCalendar(
          "gotoDate",
          date
        );
      }
    },
    eventLimit: true,
    aspectRatio: 1.75,
    eventResize: _this.calendarOnResize,
    eventLimitText: "más",
    buttonText: {
      today: "Hoy",
      month: "Mes",
      day: "Día",
      prev: "<",
      next: ">",
      prevYear: "Ant Año",
      nextYear: "Prox. Año",
      year: "Año",
      week: "Semana",
    },
  };

  this.newTask = function () {
    $state.go("dashboard.departments.department.tasks.task", {
      taskId: "new",
    });
  };
};
